import React from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { BookedService, ServiceDto } from '../../../../api'
import { actualShowState } from '../../../../state/ActualShow.state'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { ServiceSelectionPanel } from './ServiceSelectionPanel'

export const ServicesScreen = () => {
/* STATE */
const actualShowBookedServices = useLocalState(actualShowState.actualShowBookedServices$, actualShowState.actualShowBookedServices$.value)
const showServices = useLocalState<ServiceDto[]>(actualShowState.actualShowServices$, actualShowState.actualShowServices$.value)

/* DERIVED STATE */
const bookedServicesNoType = React.useMemo(
  () => actualShowBookedServices?.filter((s) => !showServices?.find((so) => so?.id === s?.serviceId)?.type),
  [actualShowBookedServices, showServices]
)

/* TEMPLATE */
return (
  <div>
    {bookedServicesNoType?.length > 0 && (
      <>
        <h3>Ihre schon gebuchten Services.</h3>
        <DataTable value={bookedServicesNoType}>
            <Column header='Bezeichnung' body={(service: BookedService) => showServices?.find((s) => s?.id === service?.serviceId)?.name} />
            <Column header='Menge' body={(service: BookedService) => service?.quantity} />
            <Column header='Preis' body={(service: BookedService) => service?.totalPrice?.toFixed(2).replace('.', ',') + ' €'} />
          </DataTable>
        </>
      )}

      {/* Services ohne Typ – allgemeine Services */}
      <ServiceSelectionPanel title='Wählen Sie Ihre Services:' />
    </div>
  )
}
